export const FETCH_PROPERTY_DETAILS = 'FETCH_PROPERTY_DETAILS';
export const FETCH_PROPERTY_DETAILS_SUCCESS = 'FETCH_PROPERTY_DETAILS_SUCCESS';
export const FETCH_PROPERTY_DETAILS_ERROR = 'FETCH_PROPERTY_DETAILS_ERROR';

export const PROPERTY_OPERATION_START = 'PROPERTY_OPERATION_START';
export const PROPERTY_OPERATION_END = 'PROPERTY_OPERATION_END';
export const FETCH_LEASE_PROPERTIES_V2 = 'FETCH_LEASE_PROPERTIES_V2';
export const FETCH_BUILDING_UNITS = 'FETCH_BUILDING_UNITS';

export const FETCH_POA_CUSTOMER = 'FETCH_POA_CUSTOMER';
export const FETCH_POA_CUSTOMER_SUCCESS = 'FETCH_POA_CUSTOMER_SUCCESS';
export const FETCH_POA_CUSTOMER_FAILURE = 'FETCH_POA_CUSTOMER_FAILURE';

export const FETCH_OFF_PLAN_PROJECTS = 'FETCH_OFF_PLAN_PROJECTS';
export const FETCH_OFF_PLAN_PROJECTS_SUCCESS = 'FETCH_OFF_PLAN_PROJECTS_SUCCESS';
export const FETCH_OFF_PLAN_PROJECTS_FAILURE = 'FETCH_OFF_PLAN_PROJECTS_FAILURE';

export const FETCH_OFF_PLAN_UNIT_USAGE = 'FETCH_OFF_PLAN_UNIT_USAGE';
export const FETCH_OFF_PLAN_UNIT_USAGE_SUCCESS = 'FETCH_OFF_PLAN_UNIT_USAGE_SUCCESS';
export const FETCH_OFF_PLAN_UNIT_USAGE_FAILURE = 'FETCH_OFF_PLAN_UNIT_USAGE_FAILURE';

export const FETCH_OFF_PLAN_UNIT_TYPES = 'FETCH_OFF_PLAN_UNIT_TYPES';
export const FETCH_OFF_PLAN_UNIT_TYPES_SUCCESS = 'FETCH_OFF_PLAN_UNIT_TYPES_SUCCESS';
export const FETCH_OFF_PLAN_UNIT_TYPES_FAILURE = 'FETCH_OFF_PLAN_UNIT_TYPES_FAILURE';

export const FETCH_MORTGAGE_TYPES = 'FETCH_MORTGAGE_TYPES';
export const FETCH_MORTGAGE_TYPES_SUCCESS = 'FETCH_MORTGAGE_TYPES_SUCCESS';
export const FETCH_MORTGAGE_TYPES_FAILURE = 'FETCH_MORTGAGE_TYPES_FAILURE';

export const FETCH_PROPERTY_DETAILS_SUCCESS_MAP = 'FETCH_PROPERTY_DETAILS_SUCCESS_MAP';

export const CLEAR_PROPERTIES_DATA = 'CLEAR_PROPERTIES_DATA';
export const WORKFLOW_ID_CERT_SITE_PLAN_PLOT = '1039';
export const WORKFLOW_ID_CERT_VERIFICATION_PLOT = '1036';
export const WORKFLOW_ID_TITLE_DEED_PLOT = '1035';
